import Admin from './admin.route';
import Gudang from './gudang.route';
import Kasir from './kasir.route';
import Penjualan from './penjualan.route';
import Bonus from './bonus.route';
import StockStockist from './stock-stockist.route';
import CustomerService from './customer-servivce.route';

let pusat = [];

pusat = pusat.concat(
    Admin.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Admin'
        }
    })),
    Gudang.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Gudang'
        }
    })),
    Kasir.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Kasir'
        }
    })),
    Penjualan.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Penjualan'
        }
    })),
    Bonus.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Bonus'
        }
    })),
    CustomerService.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Customer Service'
        }
    })),
    StockStockist
);

export default pusat;
